import { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Row, Spinner } from "react-bootstrap";
import * as THREE from "three";
import { generarSceneModal } from "../funciones/generarSceneModal";
import { generarScenePerson } from "../funciones/generarScenePerson";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { BsFillCartPlusFill, BsWindowSidebar } from "react-icons/bs";
const ModalDestacado = (props) => {
  const [loading, setLoading] = useState(true);
  const [listo, setListo] = useState(false);
  const refRenderer2 = useRef(null);
  const refRenderer = useRef(null);
  const refSceneModal1 = useRef(null);
  const refObjetoModal = useRef(null);
  const refControls = useRef(null);
  const refModalBody = useRef(null);
  const refTick = useRef(null);
  const refModal = useRef(null);
  const refScenesModal = useRef(null);
  const dracoLoader = new DRACOLoader();
  const scenes = [];
  // refScenesModal.current = [];
  // refRenderer.current = props.renderer;
  // const refRenderer = useRef(null)
  const scenes2 = [];
  dracoLoader.setDecoderPath("/draco/"); // use a full url path
  const gltf = new GLTFLoader();
  gltf.setDRACOLoader(dracoLoader);
  // const canvas2 = document.getElementById("canvas2");
  const canvas = document.getElementById("canvas-modal");
  refObjetoModal.current = props.model;
  // console.log("refobjetomodal es, ", refObjetoModal.current);
  // let lente21 = undefined;
  // useEffect(() => {
  //   const funcion = async () => {
  //     const lenteTemporal = await gltf.loadAsync("./lente21.gltf");
  //     lente21 = lenteTemporal.scene;
  //   };
  //   funcion();
  // }, []);

  function updateSize() {
    // if (!refObjetoModal.current) return;
    const canvas = document.getElementById("canvas-modal");

    if (!canvas) return;
    const width4 = canvas.clientWidth;
    const height4 = canvas.clientHeight;
    //  const elem4 = refSceneModal1.current.userData.element;

    // scene.userData.camera.aspect = elem.width / elem.height;
    // scene.userData.camera.updateProjectionMatrix();
    // console.log("canvas .canvas es, ", canvas.canvas);
    // refRenderer.current.setSize(width, height, false);

    // canvas.position = "absolute";
    if (canvas.width !== width4 || canvas.height !== height4) {
      // refRenderer.current.setSize(
      //   window.innerWidth,
      //   window.innerHeight,
      //   false
      // );
      refRenderer.current.setSize(width4, height4, false);
      // scene.userData.camera.aspect = canvas.clientWidth / canvas.clientHeight;
    }
  }
  let time = Date.now();
  const tick = () => {
    refTick.current = window.requestAnimationFrame(tick);
    const canvas = document.getElementById("canvas-modal");
    if (!canvas) return;
    funcionScenesRenderer2();
    // if (refObjetoModal.current) {
    updateSize();
    // canvas.style.transform = `translateY(${window.scrollY}px)`;
    //   // console.log("tick2");
    //   const currentTime = Date.now();
    //   const deltaTime = currentTime - time;
    //   time = currentTime;

    //   refObjetoModal.current.rotation.y += deltaTime * 0.0008;
    //   refRenderer2.current.render(
    //     refSceneModal1.current,
    //     refSceneModal1.current.userData.camera
    //   );
    // }
    // if (refRenderer2.current) {
    //   refRenderer2.current.render(
    //     refSceneModal1.current,
    //     refSceneModal1.current.userData.camera
    //   );
    //   refControls.current.update();
    // }
    // console.log("tick en modal");
    // refTick.current = window.requestAnimationFrame(tick);
    // const width = canvas.clientWidth;
    // const height = canvas.clientHeight;
    // const elem = refSceneModal1.current.userData.element;

    // scene.userData.camera.aspect = elem.width / elem.height;
    // scene.userData.camera.updateProjectionMatrix();
    // console.log("canvas .canvas es, ", canvas.canvas);
    // refRenderer.current.setSize(width, height, false);
    // canvas.style.transform = `translateY(${window.scrollY}px)`;
    // console.log("funciona tick");
    // console.log("refScenesModal", refScenesModal.current);
    // refScenesModal.current.forEach(function (scene, index) {
    //   // get the element that is a place holder for where we want to
    //   // draw the scene
    //   const element = scene.userData.element;
    //   const camera = scene.userData.camera;

    //   // get its position relative to the page's viewport
    //   const rect = element.getBoundingClientRect();

    //   // pickCorgi.pick(mouseCorgi, scene, scene.userData.camera);
    //   // check if it's offscreen. If so skip it
    //   console.log("entra aca");
    //   if (
    //     rect.bottom < 0 ||
    //     rect.top > refRenderer.current.domElement.clientHeight ||
    //     rect.right < 0 ||
    //     rect.left > refRenderer.current.domElement.clientWidth
    //   ) {
    //     return; // it's off screen
    //   }

    //   // set the viewport
    //   const width = rect.right - rect.left;
    //   const height = rect.bottom - rect.top;
    //   const left = rect.left;
    //   const bottom = refRenderer.current.domElement.clientHeight - rect.bottom;

    //   refRenderer.current.setViewport(left, bottom, width, height);
    //   refRenderer.current.setScissor(left, bottom, width, height);
    //   console.log("entra en scenes");
    //   //camera.aspect = width / height; // not changing in this example
    //   scene.userData.camera.aspect = rect.width / rect.height;
    //   scene.userData.camera.updateProjectionMatrix();

    //   refRenderer.current.render(scene, camera);
    // });
  };
  useEffect(() => {
    // console.log("props show es, ", props.show);
  }, [props.show]);

  const funcionResize3 = () => {
    // const canvas2 = document.getElementById("canvas2");
    if (window.innerWidth < 424) {
      if (refObjetoModal.current) {
        // console.log("ref objeto en tick es, ", refObjetoModal.current);
        if (props.tipo === "lente21") {
          const temporal1 = 3000 - window.innerWidth;
          const temporal2 = (temporal1 * 100) / 3000;
          const temporal3 = (temporal2 * 3) / 100;
          refObjetoModal.current.scale.set(
            3 - temporal3,
            3 - temporal3,
            3 - temporal3
          );
        } else if (props.tipo === "lente23") {
          const temporal1 = 3000 - window.innerWidth;
          const temporal2 = (temporal1 * 100) / 3000;
          const temporal3 = (temporal2 * 0.2) / 100;
          refObjetoModal.current.scale.set(
            0.2 - temporal3,
            0.2 - temporal3,
            0.2 - temporal3
          );
        } else if (props.tipo === "lente22") {
          const temporal1 = 3000 - window.innerWidth;
          const temporal2 = (temporal1 * 100) / 3000;
          const temporal3 = (temporal2 * 14) / 100;
          refObjetoModal.current.scale.set(
            14 - temporal3,
            14 - temporal3,
            14 - temporal3
          );
        }
      }
    } else {
      if (refObjetoModal.current) {
        // console.log("ref objeto en tick es, ", refObjetoModal.current);
        if (props.tipo === "lente21") {
          const temporal1 = 3000 - window.innerWidth;
          const temporal2 = (temporal1 * 100) / 3000;
          const temporal3 = (temporal2 * 1.5) / 100;
          refObjetoModal.current.scale.set(
            1.5 - temporal3,
            1.5 - temporal3,
            1.5 - temporal3
          );
        } else if (props.tipo === "lente23") {
          const temporal1 = 3000 - window.innerWidth;
          const temporal2 = (temporal1 * 100) / 3000;
          const temporal3 = (temporal2 * 0.2) / 100;
          refObjetoModal.current.scale.set(
            0.2 - temporal3,
            0.2 - temporal3,
            0.2 - temporal3
          );
        } else if (props.tipo === "lente22") {
          const temporal1 = 3000 - window.innerWidth;
          const temporal2 = (temporal1 * 100) / 3000;
          const temporal3 = (temporal2 * 14) / 100;
          refObjetoModal.current.scale.set(
            14 - temporal3,
            14 - temporal3,
            14 - temporal3
          );
        }
      }
    }
  };

  const funcionResize = () => {
    if (window.innerWidth < 520) {
      if (props.tipo === "lente21") {
        refObjetoModal.current.scale.set(0.8, 0.8, 0.8);
      } else if (props.tipo === "lente22") {
        refObjetoModal.current.scale.set(0.16, 0.16, 0.16);
      } else if (props.tipo === "lente23") {
        refObjetoModal.current.scale.set(0.1, 0.1, 0.1);
        refObjetoModal.current.position.y = -0.4;
      }
    }
  };
  window.addEventListener("resize", funcionResize);
  const closeModal = () => {
    window.removeEventListener("resize", funcionResize, true);
    window.cancelAnimationFrame(refTick.current);

    let i = 0;
    // refObjetoModal.current.children.forEach(function (item) {
    //   i = i + 1;
    //   item.name = `lente21_${i}`;

    //   item.children.forEach(function (i2) {
    //     i = i + 1;
    //     i2.name = `lente21_${i}`;

    //     i2.children.forEach(function (i3) {
    //       i = i + 1;
    //       i3.name = `lente21_${i}`;
    //       i3.children.forEach(function (i4) {
    //         i = i + 1;

    //         if (i4.material && i4.geometry) {
    //           console.log("se hizo dispose!!!");
    //           i4.material.dispose();
    //           i4.geometry.dispose();
    //         }
    //         i4.name = `lente21_${i}`;
    //       });
    //     });
    //   });
    // });
    refSceneModal1.current.remove(refObjetoModal.current);
    // refObjetoModal.current = null;

    if (refRenderer.current) {
      refRenderer.current.dispose();
      refRenderer.current.forceContextLoss();
      refRenderer.current.domElement = null;
      refRenderer.current = null;
    }
    // refRenderer.current = null;
    // const canvas = document.getElementById("canvas-modal");
    // canvas.remove();
    props.callbackHideModal();
  };

  useEffect(() => {
    funcionResize();
  }, [props.tipo, props.model]);

  useEffect(() => {
    if (props.activarLenteModal && listo) {
      // refModal.current.style.zIndex = "999999";
    }
  }, [props.activarLenteModal, listo]);
  const funcionScenesRenderer2 = () => {
    const canvas = document.getElementById("canvas-modal");

    // return;
    if (scenes.length === 0) return;
    scenes.forEach(function (scene, index) {
      // const element = scene.userData.element;
      // get the element that is a place holder for where we want to
      // draw the scene
      const element = scene.userData.element;
      const camera = scene.userData.camera;

      // get its position relative to the page's viewport
      const rect = element.getBoundingClientRect();

      // check if it's offscreen. If so skip it
      if (
        rect.bottom < 0 ||
        rect.top > refRenderer.current.domElement.clientHeight ||
        rect.right < 0 ||
        rect.left > refRenderer.current.domElement.clientWidth
      ) {
        return; // it's off screen
      }
      // set the viewport
      const width = rect.right - rect.left;
      const height = rect.bottom - rect.top;

      // const left = rect.left;
      // const left = 17;
      // const left = 17;
      // const bottom =
      //   refRenderer.current.domElement.clientHeight - rect.bottom + 100;

      const left = refRenderer.current.domElement.clientWidth - rect.width - 17;
      const bottom =
        refRenderer.current.domElement.clientHeight - rect.height - 17;

      refRenderer.current.setViewport(left, bottom, width, height);
      refRenderer.current.setScissor(left, bottom, width, height);

      //camera.aspect = width / height; // not changing in this example
      scene.userData.camera.aspect = rect.width / rect.height;
      scene.userData.camera.updateProjectionMatrix();

      refRenderer.current.render(scene, camera);
    });
    refRenderer.current.setSize(canvas.clientWidth, canvas.clientHeight, false);
  };
  return (
    <Container fluid>
      <Modal
        ref={refModal}
        show={props.show}
        onHide={() => {
          closeModal();
        }}
        style={{ zIndex: "99991", display: "block", width: "100%" }}
        // style={{ zIndex: listo ? "99991" : "99991" }}
        size="xl"
        id="modal-1"
        centered
        onEntered={async () => {
          const canvas = document.getElementById("canvas-modal");
          const modalbody = document.getElementById("modalbody");

          // if (props.tipo === "lente21") {
          //   // console.time("lente21");
          //   const [sceneModal1, divModal1] = generarSceneModal("scenemodal1");
          //   refSceneModal1.current = sceneModal1;
          //   // const lentesModal1 = await gltf.loadAsync("./lente21.gltf");
          //   // refObjetoModal.current = lentesModal1.scene;
          //   // refObjetoModal.current.scale.set(10, 10, 10);
          //   refObjetoModal.current.position.x = 0;
          //   refObjetoModal.current.position.z = 0;
          //   // const temporal1 = 1000 - canvas2.width;
          //   const temporal1 = 3000 - window.innerWidth;
          //   const temporal2 = (temporal1 * 100) / 3000;
          //   const temporal3 = (temporal2 * 1.5) / 100;
          //   // console.log("temporal 3 es, ", temporal3);
          //   refObjetoModal.current.scale.set(
          //     1.5 - temporal3,
          //     1.5 - temporal3,
          //     1.5 - temporal3
          //   );
          //   // refObjetoModal.current.matrixWorldNeedsUpdate = true;
          //   refSceneModal1.current.add(refObjetoModal.current);
          //   console.timeEnd("lente21");
          //   // refObjetoModal.current.rotation.y += Math.PI * 0.25;
          // } else if (props.tipo === "lente23") {
          //   console.time("lente23");
          //   const [sceneModal1, divModal1] = generarSceneModal("scenemodal1");
          //   refSceneModal1.current = sceneModal1;
          //   // const lentesModal1 = await gltf.loadAsync("./lente23.gltf");
          //   // refObjetoModal.current = lentesModal1.scene;
          //   // refObjetoModal.current.scale.set(0.1, 0.1, 0.1);
          //   refObjetoModal.current.position.x = 0;
          //   // refObjetoModal.current.position.z = -1.9;
          //   refObjetoModal.current.position.z = 0;
          //   // const temporal1 = 1000 - canvas2.width;
          //   const temporal1 = 3000 - window.innerWidth;
          //   const temporal2 = (temporal1 * 100) / 3000;
          //   const temporal3 = (temporal2 * 0.25) / 100;
          //   // console.log("temporal 3 es, ", temporal3);
          //   console.log("window inner width es, ", window.innerWidth);
          //   refObjetoModal.current.scale.set(
          //     0.25 - temporal3,
          //     0.25 - temporal3,
          //     0.25 - temporal3
          //   );
          //   // refObjetoModal.current.matrixWorldNeedsUpdate = true;
          //   refSceneModal1.current.add(refObjetoModal.current);
          //   console.timeEnd("lente23");
          //   // objeto23.rotation.y += Math.PI * 0.25;
          // } else if (props.tipo === "lente22") {
          //   console.time("lente22");
          //   const [sceneModal1, divModal1] = generarSceneModal("scenemodal1");
          //   refSceneModal1.current = sceneModal1;
          //   // const lentesModal1 = await gltf.loadAsync("./lente23.gltf");
          //   // refObjetoModal.current = lentesModal1.scene;
          //   // refObjetoModal.current.scale.set(0.1, 0.1, 0.1);
          //   refObjetoModal.current.position.x = -0.25;
          //   // refObjetoModal.current.position.z = -1.9;
          //   refObjetoModal.current.position.z = 0;
          //   // const temporal1 = 1000 - canvas2.width;
          //   const temporal1 = 3000 - window.innerWidth;
          //   const temporal2 = (temporal1 * 100) / 3000;
          //   const temporal3 = (temporal2 * 14) / 100;
          //   // console.log("temporal 3 es, ", temporal3);
          //   refObjetoModal.current.scale.set(
          //     14 - temporal3,
          //     14 - temporal3,
          //     14 - temporal3
          //   );
          //   // refObjetoModal.current.matrixWorldNeedsUpdate = true;
          //   refSceneModal1.current.add(refObjetoModal.current);
          //   console.timeEnd("lente22");
          //   // objeto23.rotation.y += Math.PI * 0.25;
          // }
          const [sceneModal1, divModal1] = generarSceneModal("scenemodal1");
          // const [sceneModal1, divModal1] = generarSceneSelect("scenemodal1");
          refSceneModal1.current = sceneModal1;
          // const temporal1 = 1000 - canvas.width;
          // const temporal2 = (temporal1 * 100) / 3000;
          // const temporal3 = (temporal2 * 1.5) / 100;
          // // console.log("temporal 3 es, ", temporal3);
          // refObjetoModal.current.scale.set(
          //   1.5 - temporal3,
          //   1.5 - temporal3,
          //   1.5 - temporal3
          // );
          refObjetoModal.current.visible = true;
          // console.log("objeto modal es, ", refObjetoModal.current);
          if (window.innerWidth < 520) {
            if (props.tipo === "lente21") {
              refObjetoModal.current.scale.set(0.8, 0.8, 0.8);
            } else if (props.tipo === "lente22") {
              refObjetoModal.current.scale.set(0.12, 0.12, 0.12);
            } else if (props.tipo === "lente23") {
              refObjetoModal.current.scale.set(0.1, 0.1, 0.1);
              refObjetoModal.current.position.y = -0.4;
            }
          } else {
            if (props.tipo === "lente21") {
              refObjetoModal.current.scale.set(0.9, 0.9, 0.9);
            } else if (props.tipo === "lente22") {
              refObjetoModal.current.scale.set(0.21, 0.21, 0.21);
              refSceneModal1.current.userData.camera.position.z = -4;
            } else if (props.tipo === "lente23") {
              refObjetoModal.current.scale.set(0.14, 0.14, 0.14);
              refObjetoModal.current.position.y = -0.4;
            }
          }
          refObjetoModal.current.position.z = 0;
          refSceneModal1.current.add(refObjetoModal.current);
          refObjetoModal.current.rotation.y = Math.PI * 1;
          // const geometry = new THREE.BoxGeometry(1, 1, 1);
          // const material = new THREE.MeshBasicMaterial({ color: 0xffff00 });
          // const mesh = new THREE.Mesh(geometry, material);
          // refSceneModal1.current.add(mesh);
          // scenes2.push(sceneModal1);
          scenes.push(refSceneModal1.current);
          // props.activarZindex(sceneModal1);
          document.getElementById("div-canvas").appendChild(divModal1);
          // refContentModal1.current.style.backgroundColor = "#FF0000";
          // refContentModal1.current.appendChild(refDivModal1.current);
          // refRenderer2.current = new THREE.WebGLRenderer({
          //   canvas: canvas2,
          //   alpha: true,
          //   antialias: true,
          //   premultipliedAlpha: false,
          // });
          refRenderer.current = new THREE.WebGLRenderer({
            canvas: canvas,
            alpha: true,
            antialias: true,
            premultipliedAlpha: false,
          });

          refRenderer.current.setScissorTest(false);
          refRenderer.current.clear();
          refRenderer.current.setScissorTest(true);

          // refRenderer.current.gammaOutput = true;
          refRenderer.current.setPixelRatio(
            Math.min(window.devicePixelRatio, 2)
          );
          // refRenderer2.current.setClearColor(0xffffff);
          // refRenderer2.current.setScissorTest(false);
          // refRenderer2.current.clear();

          // refRenderer2.current = new THREE.WebGLRenderer({
          //   canvas: canvas,
          //   alpha: true,
          //   antialias: true,
          //   premultipliedAlpha: false,
          // });
          // canvas.style.transform = `translateY(${window.scrollY}px)`;
          // console.log("funciona1");
          // refRenderer2.current.setClearColor(0xffffff);
          refRenderer.current.setScissorTest(false);
          refRenderer.current.clear();

          // refRenderer.current.setClearColor(0xe0e0e0);
          refRenderer.current.setScissorTest(true);

          refRenderer.current.setSize(
            canvas.clientWidth,
            canvas.clientHeight,
            false
          );
          // refRenderer.current.setClearColor(0xe0e0e0);
          // const element4 = refSceneModal1.current.userData.element;

          // get its position relative to the page's viewport
          // const rect = element4.getBoundingClientRect();

          // check if it's offscreen. If so skip it
          // if (
          //   rect.bottom < 0 ||
          //   rect.top > refRenderer.current.domElement.clientHeight ||
          //   rect.right < 0 ||
          //   rect.left > refRenderer.current.domElement.clientWidth
          // ) {
          //   return; // it's off screen
          // }

          // set the viewport
          // const width = rect.right - rect.left;
          // const height = rect.bottom - rect.top;
          // const left = rect.left;
          // const bottom =
          //   refRenderer.current.domElement.clientHeight - rect.bottom;

          // refRenderer.current.setViewport(left, bottom, width, height);
          // refRenderer.current.setScissor(left, bottom, width, height);
          // refRenderer.current.setClearColor(0xe0e0e0);
          // refRenderer.current.setScissorTest(true);
          // refRenderer.current.setClearColor(0xe0e0e0);
          // refRenderer.current.physicallyCorrectLights = true;
          // refRenderer.current.toneMapping = THREE.ACESFilmicToneMapping;
          // refRenderer.current.toneMapping = THREE.ReinhardToneMapping;
          // refRenderer.current.outputEncoding = THREE.sRGBEncoding;
          // refRenderer.current.toneMappingExposure = 1;
          // refRenderer.current.setSize(

          //   window.innerWidth,
          //   window.innerHeight,
          //   false
          // );
          // refRenderer.current.physicallyCorrectLights = true;
          // refRenderer.current.outputEncoding = THREE.sRGBEncoding;
          // refRenderer.current.toneMapping = THREE.ReinhardToneMapping;
          // refRenderer.current.toneMappingExposure = 3;
          // refRenderer.current.shadowMap.enabled = true;
          // refRenderer.current.shadowMap.type = THREE.PCFSoftShadowMap;
          // refRenderer.current.setPixelRatio(
          //   Math.min(window.devicePixelRatio, 2)
          // );
          // refRenderer.current.gammaOutput = true;
          refRenderer.current.setPixelRatio(
            Math.min(window.devicePixelRatio, 2)
          );
          // refRenderer.current.render(
          //   refSceneModal1.current,
          //   refSceneModal1.current.userData.camera
          // );

          // console.log("size canvas width es, ", canvas2.width);
          // console.log("size canvas height es, ", canvas2.height);
          // console.log("window canvas width es, ", window.innerWidth);
          // console.log("window canvas height es, ", window.innerHeight);
          // const temporal1 = canvas2.width / canvas2.height;
          //600 / 300
          //2
          //
          ///////////
          //1 == Cuadrado
          //2 = reducir el tamaño
          //1000 === 100
          //680 ==
          //1000 - 600 =400

          ///1000 === 100
          ///400 === x = 40

          //100 == 10
          //40 == x
          //40 * 10/100
          // const temporal1 = 1000 - canvas2.width;
          // const temporal2 = (temporal1 * 100) / 1000;
          // const temporal3 = (temporal2 * 10) / 100;
          // console.log("temporal 3 es, ", temporal3);
          // refObjetoModal.current.scale.set(
          //   10 - temporal3,
          //   10 - temporal3,
          //   10 - temporal3
          // );
          // refSceneModal1.current.add(refObjetoModal.current);
          // refControls.current = new OrbitControls(
          //   refSceneModal1.current.userData.camera,
          //   canvas2,
          //   scene.userData.element
          // );
          // refControls.current.enableDamping = true;
          // refControls.current.minDistance = 2;
          // refControls.current.maxDistance = 5;
          // refControls.current.enablePan = false;
          // refControls.current.enableZoom = true;

          setLoading(false);
          setListo(true);
          setTimeout(() => {
            // document.getElementById("canvas-modal").style.zIndex = "99993";
            // document.getElementById("modal-1").style.zIndex = "999999";
            // document.getElementById("canvas-modal").style.zIndex = "99993";
            // document.getElementById("canvas-modal").style.height = "100%";
            // document.getElementById("canvas-modal").style.width = "100%";
            // document.getElementById("canvas-modal").style.background = "blue";
            // document.getElementById("boton-cerrar-modal").style.zIndex =
            //   "9999999999";
            // document.getElementById("div-modal-element").style.zIndex = "99999";
            // console.log("webgl info es, ", refRenderer.current.info);
          }, 1000);
          // refCanvas2.current.style.zIndex = "9000";
          tick();
        }}
      >
        <Modal.Header closeButton style={{ background: "#eeeeee" }}>
          {/* <Modal.Title>
            Glasses {props.tipo === "lente21" && <span>Model 1</span>}
            {props.tipo === "lente22" && <span>Model 2</span>}
            {props.tipo === "lente23" && <span>Model 3</span>}
          </Modal.Title> */}
        </Modal.Header>
        <Modal.Body
          ref={refModalBody}
          id="modalbody"
          style={{ background: "#eeeeee" }}
        >
          {/* <div
            style={{
              height: "600px",
              width: "100%",
              background: "red",
              position: "relative",
            }}
          > */}
          <canvas
            className="webgl2"
            id="canvas-modal"
            // style={{ zIndex: "99994", margin: "0px", padding: "0px" }}
            style={{
              zIndex: "0",
              margin: "0px",
              padding: "0px",
              width: "100%",
              height: "100%",
            }}
          ></canvas>
          <div
            style={{
              width: "100%",
              // background: "green",
              background: "#FFFFFF",
              height: "300px",
              borderRadius: "15px",
            }}
            className="mx-auto d-block div-modal2"
            id="div-canvas"
          ></div>
          {/* </div> */}
          {/* <div id="div-canvas"></div> */}
          {/* <Container
            fluid
            //  className="container-principal"
          >
            <Row>
              {loading && <Spinner animation="border" variant="info" />}
            </Row>
          </Container> */}
          {/* <div id="div-canvas"></div> */}
          {props.tipo === "lente21" && (
            <p className="text-center  mb-3 mt-5" style={{ fontSize: "30px" }}>
              <b>Classic</b>
            </p>
          )}
          {props.tipo === "lente22" && (
            <p className="text-center  mb-3 mt-5" style={{ fontSize: "30px" }}>
              <b>Modern</b>
            </p>
          )}
          {props.tipo === "lente23" && (
            <p className="text-center  mb-3 mt-5" style={{ fontSize: "30px" }}>
              <b>Casual</b>
            </p>
          )}
        </Modal.Body>
        <Modal.Footer
          style={{
            zIndex: "99997",
            background: "#eeeeee",
            position: "relative",
          }}
          className="d-flex justify-content-between"
        >
          <div></div>
          <p className="text-center">
            <i>Can rotate</i>
          </p>

          <Button
            variant="secondary"
            onClick={() => {
              closeModal();
              // // setModal1(false);
              // // refPickHelper1.current.setModal1(false);
              // // refPickHelper2.current.setModal1(false);
              // // refPickHelper3.current.setModal1(false);
              // props.callbackHideModal();
              // // setShow(false);
            }}
            // style={{
            //   zIndex: "999999",
            //   position: "relative",
            // }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <canvas
        className="webgl2"
        //   ref={refCanvas2}
        // ref={refContentModal1}
        id="c"
        style={{ zIndex: "99994" }}
      ></canvas> */}
    </Container>
  );
};

export default ModalDestacado;
